import { TypographyVariantsOptions } from '@mui/material/styles';
import { palette } from './palette';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    h1?: React.CSSProperties;
    h2?: React.CSSProperties;
    h3?: React.CSSProperties;
    h4?: React.CSSProperties;
    h5?: React.CSSProperties;
    text1?: React.CSSProperties;
    text2?: React.CSSProperties;
    text3?: React.CSSProperties;
    text4?: React.CSSProperties;
    text5?: React.CSSProperties;

    tablePrimary?: React.CSSProperties;
    tableSecondary?: React.CSSProperties;

    button?: React.CSSProperties;
    link?: React.CSSProperties;
    tableLink?: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    h1?: React.CSSProperties;
    h2?: React.CSSProperties;
    h3?: React.CSSProperties;
    h4?: React.CSSProperties;
    h5?: React.CSSProperties;
    text1?: React.CSSProperties;
    text2?: React.CSSProperties;
    text3?: React.CSSProperties;
    text4?: React.CSSProperties;
    text5?: React.CSSProperties;

    tablePrimary?: React.CSSProperties;
    tableSecondary?: React.CSSProperties;

    button?: React.CSSProperties;
    link?: React.CSSProperties;
    tableLink?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h1: true;
    h2: true;
    h3: true;
    h4: true;
    h5: true;
    text1: true;
    text2: true;
    text3: true;
    text4: true;
    text5: true;

    tablePrimary: true;
    tableSecondary: true;
    tableLink: true;

    button: true;
    link: true;
  }
}

export const fontFamily = "'Inter Variable', Arial";

export const typographyBase = {
  h1: {
    fontSize: '1.75rem',
    lineHeight: 1.71,
    fontWeight: 600,
    fontFamily,
  },
  h2: {
    fontSize: '1.125rem',
    lineHeight: 1.5,
    fontWeight: 600,
    fontFamily,
  },
  h3: {
    fontSize: '1.125rem',
    lineHeight: 1.33,
    fontWeight: 500,
    fontFamily,
  },
  h4: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    fontWeight: 600,
    fontFamily,
  },
  h5: {
    fontSize: '1rem',
    lineHeight: '1.5625rem',
    fontWeight: 500,
    fontFamily,
  },
  text1: {
    fontSize: '0.8125rem',
    lineHeight: 1.62,
    fontWeight: 400,
    fontFamily,
  },
  text2: {
    fontSize: '0.875rem',
    lineHeight: 1.56,
    fontWeight: 500,
    fontFamily,
  },
  text3: {
    fontSize: '0.75rem',
    lineHeight: 1.5,
    fontWeight: 500,
    fontFamily,
  },
  text4: {
    fontSize: '0.75rem',
    lineHeight: 1.33,
    fontWeight: 400,
    fontFamily,
  },
  text5: {
    fontSize: '0.75rem',
    lineHeight: 1.5,
    fontWeight: 400,
    fontFamily,
  },
  tablePrimary: {
    fontSize: '0.8125rem',
    lineHeight: 1.38,
    fontWeight: 400,
    fontFamily,
  },
  tableSecondary: {
    fontSize: '0.75rem',
    lineHeight: 1.5,
    fontWeight: 400,
    fontFamily,
  },
  tableLink: {
    fontSize: '0.8125rem',
    lineHeight: 1.38,
    fontWeight: 400,
    fontFamily,
    color: palette.grey[700],
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export const typography: TypographyVariantsOptions = {
  fontFamily,
  ...typographyBase,
  link: {
    ...typographyBase.text1,
    color: palette.grey[700],
    textDecoration: 'none',
  },
  button: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 600,
    fontFamily,
  },
};
